export default "__VITE_ASSET__CZLDrz76__"